import { computed } from 'vue'
import type { ComputedRef } from 'vue'
import useI18n from '@app/shared/vue/composables/use-I18n'
import { useSegmentsStore } from '@app/insights/store/segments'
import { useFiltersStore } from '@app/insights/store/filters'
import type { Segment } from '@app/insights/types'

export function useSharedSegment(): {
  allClientsFakeSegment: ComputedRef<Pick<Segment, 'id' | 'name'>>
  selectAllClients: () => void
} {
  const I18n = useI18n()

  // The "All clients" row is not a segment: it carries only the id and the name
  // that SegmentListItem renders, and a click on it clears the selection
  // instead of loading a segment.
  const allClientsFakeSegment = computed(() => ({
    id: 0,
    name: I18n.t('segments.modal.all_companies'),
  }))

  function selectAllClients(): void {
    const segmentsStore = useSegmentsStore()
    const hasFilters = useFiltersStore().getActiveFilters.length > 0

    // Clicking "All clients" returns to the clean default view: it drops the
    // selected segment, the period selection and all active filters. This
    // also resets when no segment is selected but filters are applied (so
    // re-clicking "All clients" while already there clears your filters).
    if (segmentsStore.segment || hasFilters) {
      segmentsStore.unselectSegment()
    }
  }

  return { allClientsFakeSegment, selectAllClients }
}
